import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function DisabledQSetListNoRowsOverlay() {
  return <NoRowsOverlay title='ยังไม่มีชุดข้อสอบที่ยกเลิกใช้งาน' icon={DescriptionOutlinedIcon} />;
}
